import request from '@/utils/request'

/**
 * 获取管理员秒杀列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listAdminSeckill(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listAdminSeckill',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}